import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import { IRequirementMast, Job_Type, Req_Term } from "../models/RequirementMast";

export const Req = ({ req, loading }: { req: IRequirementMast, loading?: boolean }) => {
    const location = (rowData: IRequirementMast) => {
        return (<>{rowData.city_Name + ", " + rowData.state_Name}</>);
    };

    return (
        <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
            size="small"
            value={[req]} loading={loading}
        >
            <Column field="req_ID" header="Req ID" />
            <Column field="req_PostedBySalesManager_Name" header="Sales Manager" />
            <Column field="req_Job_Title" header="Job Title" />
            <Column field="location" header="Location" body={location} />
            <Column field="req_Term" header="Job Term" body={(rowData: IRequirementMast) => rowData.req_Term ? Req_Term[rowData.req_Term] : ""} />
            <Column field="req_Duration" header="Duration" />
            <Column field="req_EndClient" header="End Client" />
            {/* <Column field="req_Category_Name" header="Skill Category" /> */}
            <Column field="job_Type" header="Job Type" body={(rowData: IRequirementMast) => rowData.job_Type ? Job_Type[rowData.job_Type] : ""} />
            {/* <Column field="req_Priority" header="Priority" /> */}
            {/* <Column field="req_Hold_UnHoldStatus" header="Status" /> */}
            {/* <Column field="req_RequiredSkill" header="Required Skill" /> */}
        </DataTable>
    );
}